export const createCategory = (payload?: any) => ({
    type: "@saga/CREATE_CATEGORY",
    payload
});

